import {
  Modal,
  ModalContent,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  HStack
} from '@chakra-ui/react';
import React, { FC } from 'react';
import { SellNftForm } from '@app/screens/nft-marketplace/SellNftForm';
import { useMedia } from 'react-use';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const SellNftModal: FC<Props> = ({ isOpen, onClose }) => {
  const isMobile = useMedia('(max-width: 480px)', false);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
      }}
      isCentered
      motionPreset="slideInBottom"
      scrollBehavior="inside"
      size="sm"
    >
      <ModalOverlay />
      <ModalContent sx={{ maxWidth: ['100vw', '768px'], padding: '24px' }}>
        <HStack justifyContent="space-between">
          <ModalHeader whiteSpace="nowrap">Sell KpNFT</ModalHeader>
          <ModalCloseButton />
        </HStack>
        <ModalBody>
          <SellNftForm isMobile={isMobile} onParentModalClose={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
